module.exports = __webpack_public_path__ + "img/fasif-logo-no-bg.0c9b2564.png";